/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { flattenRoutes } from './helpers';
import { initialRoutes } from '../../Routes';
import { useCurrentNavItems } from './useCurrentNavItems';
import { useExpander } from '../../utils/useExpander';
import { usePageTitle } from './usePageTitle';
import { useProject } from '../project';
import { useAuth } from '../auth/AuthContext';


export function useNavigation() {
  const {status, role} = useAuth() 
  const [update, setUpdate] = React.useState<boolean>(false);
  const { launched } = useProject();

  React.useEffect(()=>setUpdate(!update), [launched]);

  const flattenedNavRoutes = flattenRoutes(initialRoutes, role).filter((route) => {
    if ((route.name?.includes('page.admin') || route.name?.includes('Admin')) && role !== 'admin') {
      return false;
    }
    return !!route.nav;
  });
  const { collapsed, handleToggle } = useExpander(true);
  const pageTitle = usePageTitle(flattenedNavRoutes);
  const { items, show } = useCurrentNavItems(flattenedNavRoutes);

  return { collapsed, toggleNav: handleToggle, pageTitle, hierarchy: items, show, status };
}
